import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseProjectPlanPhaseMilestoneReferenceRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseProjectPlanPhaseMilestoneReference";
        this.parentEnterpriseComponent = "ProjectPlanPhase";
        this.childEnterpriseComponent = "ProjectPlanPhaseMilestoneReference";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseUSID";
    }
}

export default ProjectPlanPhaseProjectPlanPhaseMilestoneReferenceRelationshipMetadata;